import React from 'react'

const fieldShadow = '0px 0px 0px 1px rgba(0,0,0,0.08), 0px 1px 2px 0px rgba(0,0,0,0.12)'
const fieldErrorShadow = '0px 0px 0px 3px rgba(225,29,72,0.15), 0px 0px 0px 1px rgba(225,29,72,1.00)'

export const fieldBoxShadow = (error: boolean): string => (error ? fieldErrorShadow : fieldShadow)

interface FormFieldLabelProps {
  label: string
  tooltip?: string
  tooltipIcon?: React.ReactNode
}

export const FormFieldLabel = ({ label, tooltip, tooltipIcon }: FormFieldLabelProps): JSX.Element => {
  return (
    <div className="inline-flex justify-start items-center gap-1">
      <div className="justify-center text-foregrounds-fg-base text-sm font-medium font-Montserrat leading-5">
        {label}
      </div>
      {typeof tooltip === 'string' && tooltip.length > 0 && (
        <div className="size-5 relative overflow-hidden flex justify-center items-center" title={tooltip}>
          {tooltipIcon}
        </div>
      )}
    </div>
  )
}

interface FormFieldErrorProps {
  show: boolean
  message: string
}

export const FormFieldError = ({ show, message }: FormFieldErrorProps): JSX.Element => {
  if (!show) {
    return <></>
  }

  return <div className="text-foregrounds-fg-error text-sm font-medium font-Montserrat leading-5">{message}</div>
}

interface FormTextInputProps {
  value: string
  onChange: (value: string) => void
  placeholder: string
  error?: boolean
}

export const FormTextInput = ({ value, onChange, placeholder, error = false }: FormTextInputProps): JSX.Element => {
  return (
    <div
      className="self-stretch h-11 pl-4 bg-backgrounds-bg-field-component rounded-md inline-flex justify-center items-center gap-1 overflow-hidden"
      style={{ boxShadow: fieldBoxShadow(error) }}>
      <input
        type="text"
        value={value}
        onChange={(event) => {
          onChange(event.target.value)
        }}
        placeholder={placeholder}
        className="flex-1 h-full bg-transparent outline-none text-foregrounds-fg-base text-sm font-semibold font-Montserrat leading-5 placeholder:text-foregrounds-fg-muted placeholder:font-semibold"
      />
    </div>
  )
}

interface FormTextAreaProps {
  value: string
  onChange: (value: string) => void
  placeholder: string
  error?: boolean
}

export const FormTextArea = ({ value, onChange, placeholder, error = false }: FormTextAreaProps): JSX.Element => {
  return (
    <div
      className="self-stretch px-4 py-2 bg-backgrounds-bg-field-component rounded-md inline-flex justify-start items-start overflow-hidden"
      style={{ boxShadow: fieldBoxShadow(error) }}>
      <textarea
        value={value}
        onChange={(event) => {
          onChange(event.target.value)
        }}
        placeholder={placeholder}
        rows={3}
        className="flex-1 bg-transparent outline-none resize-none text-foregrounds-fg-base text-sm font-medium font-Montserrat leading-5 placeholder:text-foregrounds-fg-muted placeholder:font-medium"
      />
    </div>
  )
}

export { fieldShadow }
